/*
* Default Managers edit view for authenticated users
*/

import _ from 'lodash';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as DetailFormCommon from '../inventory/detail-form/common';
import * as ReduxQueries from '../queries';

export interface IDefaultManagersEditProps extends AppComp.IAppComponentProps {
    regionDetailRegion?: any;
    regionId?: any;
    users?: any;
    offices?: any;
    updateRegion?: any;
    navigateTo?: any;
}

export interface IDefaultManagersEditState extends AppComp.IAppComponentState {
    formChanges?: any;
}

class DefaultManagersEdit extends AppComp.AppComponent<IDefaultManagersEditProps, IDefaultManagersEditState> {
    public originalFormDataCache = {};
    public kendoFormWhiteBoxSectionProps = {};

    public constructor(props: IDefaultManagersEditProps) {
        super(props, 'app.default-managers.');

        this.state = {
            formChanges: {},
        };
    }

    public componentDidUpdate() {
        let resetFormData = this.getFormChangesResetRequired();

        if (resetFormData && _.size(this.state.formChanges)) {
            this.setState({ formChanges: {} });
        }
    }

    public componentDidMount() {
        const enforce = this.enforceAdminOnly();

        if (enforce) {
            this.props.navigateTo(NavigationLinks.userDashboard());
        }
    }

    // Data transforms

    // Handlers
    // public handleViewAssociationButton(e: any) {
    //     this.props.navigateTo(NavigationLinks.associationDetail(Formatters.getInt(this.props, 'association.associationId')));
    // }

    public handleSaveButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { region: _.pick(this.props.regionDetailRegion, ['regionId', '_id']) },
            this.state.formChanges
        );

        // console.log('handleSaveButton changeData', changeData);

        this.props.updateRegion(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                this.setState({ formChanges: {} });
            } else {
                // Error during creation...
            }
        });
    }

    public handleFormInputChange(e: any, x: any) {
        // console.log('handleForminputchange', {e: e, x: x });

        const getChangesResult = this.getFormChanges(e, x);
        // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
        if (getChangesResult.applyChanges) {
            this.setState({
                formChanges: getChangesResult.formChanges
            });
        }
    }

    public handleFormOfficeCheckboxChange(e: any, x: any) {
        const officeObjId = Formatters.getStr(e, 'target.props.name');
        const officeNewAssigned = _.get(e, 'value') ? true : false;

        const { regionDetailRegion, regionId, users, offices, ...rest } = this.props;

        const formData = this.getFormData(regionDetailRegion, regionId, users, offices);

        let filteredOfficesAdd = _.reject(_.cloneDeep(_.get(formData, 'officesAdd', [])), (o) => {
            const match = (String(o) === String(officeObjId)) ? true : false;
            return match;
        });
        let filteredOfficesDelete = _.reject(_.cloneDeep(_.get(formData, 'officesDelete', [])), (o) => {
            const match = (String(o) === String(officeObjId)) ? true : false;
            return match;
        });

        let regionOfficesChanges = _.stubArray();
        if (!officeNewAssigned) {
            filteredOfficesDelete.push(officeObjId);
            regionOfficesChanges.push({ fieldName: 'officesAdd', newValue: _.cloneDeep(filteredOfficesAdd) });
            regionOfficesChanges.push({ fieldName: 'officesDelete', newValue: _.cloneDeep(filteredOfficesDelete) });
        } else {
            filteredOfficesAdd.push(officeObjId);
            regionOfficesChanges.push({ fieldName: 'officesAdd', newValue: _.cloneDeep(filteredOfficesAdd) });
            regionOfficesChanges.push({ fieldName: 'officesDelete', newValue: _.cloneDeep(filteredOfficesDelete) });
        }

        if (_.size(regionOfficesChanges)) {
            let cloneFormChanges = _.cloneDeep(this.state.formChanges);

            regionOfficesChanges.forEach((o) => {
                _.set(cloneFormChanges, o.fieldName, _.cloneDeep(o.newValue));
            });

            this.setState({ formChanges: cloneFormChanges });
        }
    }

    public handleChangeDefaultManager(e: any, obj: any) {
        return null;

        // const { orderDetailOrder, orderId, orders, association, users, statuses, serviceLevels, associationClient, orderClient, associations, clients, ...rest } = this.props;

        // const order = this.extendOrder(orderDetailOrder);

        // const formData = this.getFormData(order, orderId, orders, users, statuses, serviceLevels, associationClient, orderClient, associations, clients);

        // let orderChanges = _.stubArray();

        // const newValue = Number(Formatters.getInt(e, 'target.value'));

        // orderChanges.push({fieldName: 'status.statusId', newValue: newValue });

        // const config = _.find(OrderPricing.StatusUpdateFieldsConfig, [ 'statusId', newValue ]);

        // if (config) {
        //     if (_.size(_.get(config, 'updateDateFields', [])) > 0) {
        //         const dateUpdates = _.get(config, 'updateDateFields', []);

        //         dateUpdates.forEach((c) => {
        //             const getFieldValue = Formatters.getInt(c, 'addDays');
        //             const getFieldKey = Formatters.getStr(c, 'fieldKey');
        //             const getUpdateExisting = _.get(c, 'updateExisting', true);

        //             if (this.canUpdateExistingValue(formData, getFieldKey, getUpdateExisting)) {
        //                 const newDate = moment(new Date()).add(getFieldValue, 'days').toDate();
        //                 orderChanges.push({fieldName: getFieldKey, newValue: newDate });
        //             }
        //         });
        //     }
        // }

        // if (_.size(orderChanges)) {
        //     const changes = _.map(orderChanges, (o) => {
        //         return this.getFormChanges(
        //             {
        //                 target: {
        //                     props: {
        //                         name: _.get(o, 'fieldName')
        //                     }
        //                 },
        //                 value: _.get(o, 'newValue')
        //             },
        //             null
        //         );
        //     });

        //     const changesMapped: any = _.map(changes, 'formChangesResult');

        //     let cloneFormChanges = _.cloneDeep(this.state.formChanges);
        //     changesMapped.forEach((o) => _.merge(cloneFormChanges, o));

        //     this.setState({ formChanges: cloneFormChanges });
        // }
    }

    // Helpers
    public getFormChanges(e: any, x: any) {
        let result = {
            applyChanges: false,
            formChanges: {},
            formChangesResult: {},
        };

        let fieldName = '';
        let newValue;

        let formChangesCopy = _.cloneDeep(this.state.formChanges);

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    // console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

        if (!fieldName) { return result; }

        let applyChange = false;
        let origVal = _.get(this.originalFormDataCache, fieldName);
        let formChangesResult = {};
        if (_.isArray(origVal)) {
            if (_.isArray(newValue)) {
                if (!_.isEqual(origVal, newValue)) {
                    _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
                    _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
                    applyChange = true;
                } else {
                    applyChange = false;
                }
            } else {
                if (_.includes(origVal, newValue)) {
                    // console.log(`original array already contained val ${newValue} origVal`, origVal);
                    applyChange = false;
                } else {
                    const formChangesArr = _.get(formChangesCopy, fieldName, []);
                    // console.log(`${fieldName} formChangesArr`, formChangesArr);
                    if (_.includes(formChangesArr, newValue)) {
                        // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
                        applyChange = false;
                    } else {
                        formChangesArr.push(newValue);
                        _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
                        _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
                        applyChange = true;
                        // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
                    }
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChangesCopy, fieldName, newValue);
                _.set(formChangesResult, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChangesCopy, fieldName)) {
                    _.unset(formChangesCopy, fieldName);
                    _.set(formChangesResult, fieldName, newValue);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            result.applyChanges = true;
            result.formChanges = _.cloneDeep(formChangesCopy);
            result.formChangesResult = _.cloneDeep(formChangesResult);
        }

        // console.log(`getFormChanges returns result`, result);

        return result;
    }

    public getFormData(regionIn: any, regionId: any, users: any, offices: any) {
        const region = _.merge({}, regionIn, this.state.formChanges);

        const regionDefaultManagerUserOptions = (_.size(users)) ?
            users.map((c) => _.merge({}, { value: Formatters.getStr(c, '_id'), text: Formatters.composeUsernameLabel(c, true) }))
            : [];

        const regionSiteInspectorUserOptions = (_.size(users)) ?
            users.map((c) => _.merge({}, { value: Formatters.getStr(c, '_id'), text: Formatters.composeUsernameLabel(c, true) }))
            : [];

        const regionOfficeOptions = (_.size(offices)) ?
            offices.map((c) => _.merge({}, {
                value: Formatters.getStr(c, '_id'),
                text: Formatters.getStr(c, 'name'),
                assigned: false,
                location: _.get(c, 'location'),
            })) : [];

        const regionOffices = _.filter(offices, (o) => {
            const oReg = _.get(o, 'regions', []);
            const oRegIds = _.map(oReg, (p) => String(p._id));

            return _.includes(oRegIds, String(region._id));
        });

        let result = {
            regionId: Formatters.getInt(region, 'regionId'),

            defaultManager: _.get(region, 'defaultManager'),
            defaultSiteInspector: _.get(region, 'defaultSiteInspector'),
            description: Formatters.getStr(region, 'description'),
            name: Formatters.getStr(region, 'name'),
            regionOffices: regionOffices,
            offices: offices,

            officesExisting: _.map(regionOffices, '_id'),
            officesAdd: _.get(region, 'officesAdd', []),
            officesDelete: _.get(region, 'officesDelete', []),

            regionDefaultManagerUserOptions: (_.size(regionDefaultManagerUserOptions)) ? regionDefaultManagerUserOptions : [],
            regionSiteInspectorUserOptions: (_.size(regionSiteInspectorUserOptions)) ? regionSiteInspectorUserOptions : [],
            regionOfficeOptions: (_.size(regionOfficeOptions)) ? regionOfficeOptions : [],
        };

        if ((_.size(result.officesExisting) || _.size(result.officesAdd) || _.size(result.officesDelete)) && _.size(result.regionOfficeOptions)) {
            _.forEach(result.regionOfficeOptions, (o) => {
                const officeObjId = Formatters.getStr(o, 'value');

                const isExisting = (_.includes(result.officesExisting, officeObjId)) ? true : false;
                const isAdded = (_.includes(result.officesAdd, officeObjId)) ? true : false;
                const isDeleted = (_.includes(result.officesDelete, officeObjId)) ? true : false;

                const isAssigned = ((isExisting || isAdded) && !isDeleted) ? true : false;

                if (o.assigned !== isAssigned) {
                    _.set(o, 'assigned', isAssigned);
                }
            });
        }

        return _.merge({}, result, this.state.formChanges);
    }

    public getFormChangesCount() {
        return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'regionId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'regionId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    // Renderers
    public renderHeaderButtonToolbar = () => {
        let buttonProps = {
            bsSize: 'sm',
        };

        let saveChangesButtonProps = {
            bsStyle: 'default',
            bsSize: 'sm',
            disabled: true,
            title: this.appTextCommon('buttons.no-changes'),
        };

        if (this.getFormChangesCount()) {
            saveChangesButtonProps = {
                bsStyle: 'success',
                bsSize: 'sm',
                disabled: false,
                title: `${this.appTextCommon('buttons.save')} ${Formatters.plural(this.appTextCommon('buttons.change'), this.getFormChangesCount(), false)}`,
            };
        }

        return (
            <div>
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <Col xs={3}>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button {...saveChangesButtonProps} onClick={e => { this.handleSaveButton(e); }}><i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}</Button>
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Well>
            </div>
        );
    }

    public renderRegionInformation(formData: any) {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const inputPropsReadonly = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            rowClassName: 'kendo-form-row-readonly'
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
            colLabelXs: 4,
            colInputXs: 7,
        });

        let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
            colLabelXs: 4,
            colInputXs: 7,
        });

        return (
            <WhiteBoxPageSection {...this.kendoFormWhiteBoxSectionProps} title={this.appText('region-information')}>
                <DetailFormCommon.InventoryDetailFormSection title={this.appText('region-information')}>
                    <KendoWrappers.KendoDisabledInputHidden
                        name="_region.regionId"
                        label={this.appText('region-id')}
                        value={formData.regionId}
                        {...inputPropsReadonly}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="name"
                        label={this.appText('region-name')}
                        value={formData.name}
                        disableWrapper={false}
                        maxLength={50}
                        {...inputPropsFullWidthTextDebounced}
                    />

                    <KendoWrappers.KendoTextInputDebounced
                        name="description"
                        label={this.appText('region-description')}
                        value={formData.description}
                        disableWrapper={false}
                        maxLength={255}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </DetailFormCommon.InventoryDetailFormSection>

                <DetailFormCommon.InventoryDetailFormSection title={this.appText('region-default-users')}>
                    <KendoWrappers.KendoDropdownListInput
                        name="defaultManager.userObjectId"
                        clearable={true}
                        label={this.appText('region-default-manager')}
                        value={_.get(formData, 'defaultManager.userObjectId', '')}
                        data={formData.regionDefaultManagerUserOptions}
                        textField="text"
                        valueField="value"
                        onChange={(o) => { this.handleFormInputChange({ target: { name: 'defaultManager.userObjectId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                        {...inputPropsVirtualizedSelect}
                    />

                    <KendoWrappers.KendoDropdownListInput
                        name="defaultSiteInspector.userObjectId"
                        clearable={true}
                        label={this.appText('region-default-site-inspector')}
                        value={_.get(formData, 'defaultSiteInspector.userObjectId', '')}
                        data={formData.regionSiteInspectorUserOptions}
                        textField="text"
                        valueField="value"
                        onChange={(o) => { this.handleFormInputChange({ target: { name: 'defaultSiteInspector.userObjectId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                        {...inputPropsVirtualizedSelect}
                    />
                </DetailFormCommon.InventoryDetailFormSection>
            </WhiteBoxPageSection>
        );
    }

    public renderRegionOffices(formData: any) {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputPropsReadonly = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            rowClassName: 'kendo-form-row-readonly'
        });

        // let inputPropsOffices = _.merge({}, defaultInputProps, {
        //     // handleChange: (n, v) => { this.handleFormInputChange(n, v); },
        //     className: 'inventory-detail-input-full-width',
        //     colLabelXs: 12,
        //     colInputXs: 12,
        // });

        const inputPropsOfficeCheckbox = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormOfficeCheckboxChange(n, v); },
            colLabelXs: 6,
            colInputXs: 6,
        });

        const options = _.get(formData, 'regionOfficeOptions', []);

        let officeCheckboxes = _(options)
            .orderBy(['location.stateCode', 'location.city'], ['asc', 'asc'])
            .map((c) => {
                const regionAssignedToOffice = (_.get(c, 'assigned', false)) ? true : false;

                return (
                    <div className="edit-region-office-wrapper" key={`region-office-${c.value}`}>
                        <div>
                            <div className="pull-left">
                                <div className="edit-region-office-name">{c.text}</div>
                            </div>
                            <div className="pull-right">
                                <KendoWrappers.KendoCheckbox
                                    name={c.value}
                                    label=""
                                    value={regionAssignedToOffice}
                                    {...inputPropsOfficeCheckbox}
                                />
                            </div>
                        </div>
                        <div className="clear edit-region-office-address">
                            {Formatters.getStr(c, 'location.address1')}<br />
                            {Formatters.composeLocationCityStateZipCountry(_.get(c, 'location'))}<br />
                        </div>
                    </div>
                );
            })
            .value();

        return (
            <WhiteBoxPageSection {...this.kendoFormWhiteBoxSectionProps} title={this.appText('region-offices')}>
                <DetailFormCommon.InventoryDetailFormSection title={this.appText('region-offices-assigned-to-region')}>
                    {officeCheckboxes}
                </DetailFormCommon.InventoryDetailFormSection>
            </WhiteBoxPageSection>
        );
    }

    public render() {
        const { regionDetailRegion, regionId, users, offices, ...rest } = this.props;

        let pageTitle = this.appTextPageTitle();
        let page = (<div />);

        if (Number(Formatters.getInt(regionDetailRegion, 'regionId')) === Number(regionId) && _.size(users)) {
            const formData = this.getFormData(regionDetailRegion, regionId, users, offices);

            const pageTitleRegionName = `${Formatters.getStr(formData, 'name')} (${regionId})`;
            pageTitle = this.appTextPageTitleAppendString(pageTitleRegionName, 'page-title', true);

            // console.log('pageData', {
            //     regionId: regionId,
            //     regionDetailRegion: regionDetailRegion,
            //     formData: formData,
            //     numChanges: this.getFormChangesCount(),
            //     formChanges: this.state.formChanges,
            // });

            if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
                this.originalFormDataCache = _.cloneDeep(formData);
            }

            page = (
                <div>
                    <Row>
                        <Col xs={12} xl={9}>
                            {/* Header toolbar */}
                            <Row>
                                <Col xs={12}>
                                    <div>
                                        {this.renderHeaderButtonToolbar()}
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                {/* Region information */}
                                <Col xs={7}>
                                    <div>
                                        {this.renderRegionInformation(formData)}
                                    </div>
                                </Col>

                                {/* Region offices */}
                                <Col xs={5}>
                                    <div>
                                        {this.renderRegionOffices(formData)}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = props => ApiEndpoints.getEditRegionUrl(props.match.params.regionId);

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getEditRegionDetailRequest(
    getApiUrl(props),
    ReduxQueries.PropsAccessToken(props),
);

const mapStateToProps = (state, props) => {
    const regionId = _.get(props, 'match.params.regionId', 0);

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        regionId: regionId,
        regionDetailRegion: state.entities.editRegionDetailRegion,
        regionDetailRegionOffices: state.entities.editRegionDetailRegionOffices,
        users: state.entities.editRegionDetailUsers,
        offices: state.entities.editRegionDetailOffices,
    });
};

const mapDispatchToProps = {
    updateRegion: MutateActions.updateRegionMutateAsync,
    navigateTo: (path) => push(path),
};

const DefaultManagersEditContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(DefaultManagersEdit);

export default withRouter(DefaultManagersEditContainer);



// WEBPACK FOOTER //
// ./src/default-managers/edit.tsx